const ERROR_TYPE = {
    page: '页面异常',
    click: '点击异常',
    jump: '跳转异常',
    pay: '支付异常',
};

function getInterface(url) {
    let interfaceName = '';
    if (!url) return interfaceName;
    const array = url.split('?')[0].split('/');
    for (let index = 3; index < array.length; index++) {
        interfaceName += '/' + array[index];
    }
    return interfaceName;
}

function _checkParam(data, paramArray, index = 0) {
    const key = paramArray[index];
    if (index === paramArray.length - 1) {
        if (
            !data ||
            [undefined, null, 'null', 'undefined'].includes(data[key]) ||
            (data[key] instanceof Array && data[key].length === 0)
        ) {
            return false;
        }
        return true;
    }
    return _checkParam(data[key], paramArray, index + 1);
}

/**
 * 检查数据对象中是否包含所有需要的参数
 *
 * @param {Object} data - 需要检查的数据对象
 * @param {string} identity - 标识
 * @param {Object} paramsList - 参数列表，键为参数名称，值为参数类型
 * @param {string} bizName - 业务名称，用于错误报告中标识业务类型
 * @param {string} errorType - 错误类型，用于错误报告中标识错误的类型
 * @return {boolean} - 如果数据对象中包含所有需要的参数则返回true，否则返回false，并生成错误报告
 */
function paramsCheck(data, identity, paramsList, bizName, errorType, code, msg) {
    const emptyParams = [];
    if (paramsList) {
        for (const param of paramsList) {
            const result = _checkParam(data, param.split('.'));
            if (!result) {
                emptyParams.push(param);
            }
        }
        if (emptyParams.length > 0) {
            report(bizName, identity, data, emptyParams, errorType, code, msg);
            return false;
        }
    }
    return true;
}

/**
 * 检查数据对象中是否包含所有需要的参数
 *
 * @param {Object} data - 需要检查的数据对象
 * @param {string} identity - 标识
 * @param {Object} paramsList - 参数列表，键为参数名称，值为参数类型
 * @param {string} bizName - 业务名称，用于错误报告中标识业务类型
 * @param {string} errorType - 错误类型，用于错误报告中标识错误的类型
 * @return {boolean} - 如果数据对象中包含所有需要的参数则返回true，否则返回false，并生成错误报告
 */
function paramsInfoCheck(data, identity, paramsInfo, bizName, errorType, code, msg) {
    const emptyParams = [];
    const { params, customParamsCheckFunc } = paramsInfo;
    if (params && (!customParamsCheckFunc || customParamsCheckFunc(data))) {
        for (const param of params) {
            const result = _checkParam(data, param.split('.'));
            if (!result) {
                emptyParams.push(param);
            }
        }
        if (emptyParams.length > 0) {
            report(bizName, identity, data, emptyParams, errorType, code, msg);
            return false;
        }
    }
    return true;
}

/**
 * 上报错误信息到监控系统
 *
 * 此函数用于在业务逻辑中报告数据异常或错误情况，以便监控系统能够捕捉到这些信息并进行相应的处理
 * 它提供了一种机制，通过指定错误类型、错误信息和其他元数据，来帮助监控系统更准确地识别和分类错误
 *
 * @param {string} bizName - 业务名称，用于标识具体的业务模块
 * @param {string} identity - 标识
 * @param {Object} data - 上报的数据对象，默认为空对象如果数据对象中缺少必要参数，将按照errorType进行上报
 * @param {Array} emptyParams - 缺少的参数列表，为空数组时表示没有缺失参数
 * @param {string} errorType - 错误类型
 */
function report(bizName, identity, data = {}, emptyParams = [], errorType = 'page', code, msg) {
    if (window.monitor) {
        window.monitor.report({
            level: 'error',
            // 数据异常上报error类型：logic
            error: 'logic',
            url: window.location.href,
            // 业务-接口-数据
            msg: `标识: ${identity}, ${ERROR_TYPE[errorType]}: 返回数据缺少 ${emptyParams.join(
                ','
            )} 参数, 原始数据 data: ${JSON.stringify(data)},code :${code},msg:${msg}`,
            bizName,
        });
    }
}

module.exports = {
    report,
    getInterface,
    paramsCheck,
    paramsInfoCheck,
};
